cancelSyncWorkers